import React, {useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Work.scss'; 

const Work = () => {

  const [activeFilter, setActiveFilter] = useState('All'); 
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1});
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);

  // Fetching Data from Sanity 
  // This useEffect() is only going to happen at the start of the application/ render of our component 
  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query)
      .then((data) => {
        setWorks(data);
        setFilterWork(data);
      })
  }, [])
  
  

  // Filter pills used to categorise our works
  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    // Trigger the shuffle animation of the cards once we change the category
    setAnimateCard([{y:100, opacity:0}])

    setTimeout(() => {
      // ReTrigger the shuffle animation 
      setAnimateCard([{y:0, opacity:1}])

      // Show all the works if 'All' filter pill is clicked
      if(item === 'All'){
        setFilterWork(works);
      }
      else {
        setFilterWork(works.filter((work) => work.tags.includes(item)))
      }

    }, 500); // 500ms 
  }

  return (
    <>
      <h2 className='head-text'> My Creative <span>Portfolio</span> section</h2>

      <div className='app__work-filter'>
        {['Hackathon', 'Software Dev', 'Web Dev', 'Mobile Dev', 'Data Science', 'All'].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : '' }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5}}
        className='app__work-portfolio'
      >
        {filterWork.map((work, index) => (
          <div className='app__work-item app__flex' key={index}>

            <div className='app__work-img app__flex'>

              <img src={urlFor(work.imgUrl)} alt={work.name} />

              {/* Icons links to Project page and GitHub page */}
              <motion.div
                whileHover={{opacity: [0, 1]}}
                // staggerChildren : shows elements one after another 
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5}}
                className='app__work-hover app__flex'
              >
                {/* Eye icon which is a link to your project page */}
                <a href={work.projectLink} target='_blank' rel='noreferrer'>
                  <motion.div
                    whileInView={{scale: [0, 1]}}
                    whileHover={{scale: [1, 0.9]}}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >
                    <AiFillEye />
                  </motion.div>
                </a>

                {/* Github icon which is a link to your GitHub Source Code page */}
                <a href={work.codeLink} target='_blank' rel='noreferrer'>
                  <motion.div
                    whileInView={{scale: [0, 1]}}
                    whileHover={{scale: [1, 0.9]}}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            {/* Title and Description of project */}
            <div className='app__work-content app__flex'>
              <h4 className='bold-text'>{work.title}</h4>
              <p className='p-text' style={{ marginTop: 10}}>{work.description}</p>
              {/* Project Tags */}
              <div className='app__work-tag app__flex'>
                <p className='p-text'>{work.tags[0]}</p>
              </div>
            </div>

          </div>
        ))}
      </motion.div>
    </>
  )
}

// Double Wrapping Work Component 
export default AppWrap(
  // Wrapping the Work component in MotionWrap and giving it an extra class name of app__work
  MotionWrap(Work, 'app__works'),
  // Giving the section an id of 'work'
  'work',
  // Giving the section a grey background (alternate background colors)
  "app__primarybg"
);